module.exports = __webpack_public_path__ + "assets/img/gongju-bj.27a1f23e.jpg";